export const CREATE_WORK_TICKET_LIST_COLS = [
  {
    key: "",
    value: "meatball",
    isMeatball: true, // Custom flag to identify this as a meatball menu column
    isDisabled: true, // Set to be disabled by default
    isSortable: false,
    isFilterEnabled: false,
    width: "2%",
  },
  {
    key: "Shipping Address",
    value: "address",
    isFilterEnabled: false,
    filterType: "String",
    isCustomFilter: false,
    isSortable: true,
    isHyperLink: false,
    ellipsis: true,
    width: "12%",
  },
  {
    key: "Contact",
    value: "contactName",
    isFilterEnabled: false,
    filterType: "String",
    isCustomFilter: false,
    isSortable: true,
    isHyperLink: false,
    width: "7%",
  },
  {
    key: "Needs Attention",
    value: "needAttentionVehicles",
    isFilterEnabled: false,
    filterType: "String",
    isCustomFilter: false,
    isSortable: true,
    isHyperLink: false,
    width: "4%",
  },
  {
    key: "Entered / Not on Hold",
    value: "totalVehicles",
    isFilterEnabled: false,
    filterType: "String",
    isCustomFilter: false,
    isSortable: true,
    isHyperLink: false,
    width: "7%",
  },
  {
    key: "Source Workticket",
    value: "workTicketId",
    isFilterEnabled: false,
    filterType: "String",
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    width: "6%",
  },
  {
    key: "Work Ticket",
    value: "viewORCreate",
    isFilterEnabled: false,
    filterType: "String",
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    width: "6%",
  },
  {
    key: "Line Type",
    value: "lineType",
    isFilterEnabled: false,
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    width: "6%",
  },
  {
    key: "Request Quantity",
    value: "totalQty",
    isFilterEnabled: false,
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    width: "4%",
  },
  {
    key: "ATP Quantity",
    value: "quantityATP",
    isFilterEnabled: false,
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    width: "7%",
  },
  {
    key: "ATP Date",
    value: "dateATP",
    isFilterEnabled: false,
    isCustomFilter: false,
    isSortable: false,
    isHyperLink: false,
    ellipsis: false,
    width: "7%",
    isDate: true,
    dateFormat: "YYYY-MM-DD",
  },
  {
    key: "Hardware Name",
    value: "hardwareName",
    isFilterEnabled: false,
    filterType: "String",
    isCustomFilter: false,
    isSortable: true,
    isHyperLink: false,
    width: "18%",
  },
  {
    key: "Hardware ID",
    value: "hardwareId",
    isFilterEnabled: false,
    filterType: "String",
    isCustomFilter: false,
    isSortable: true,
    isHyperLink: false,
    width: "9%",
  },
];
